const API_URL: string = process.env.REACT_APP_BASE_URL;

//Auth
export const LOGIN_URL = API_URL + "/auth/login"; //post
export const TWO_FACT_AUTH = API_URL + "/auth/verify-twofactor"; //post
export const SEND_OTP = API_URL + "/auth/send-otp"; //post
export const VERIFY_OTP = API_URL + "/profile/verify-otp";
export const UPDATE_FORGOT_PASSWORD = API_URL + "/auth/update-forgot-password"; //post
export const LOGOUT_URL = API_URL + "/profile/logout"; //post
export const DELETE_PROFILE = API_URL + "/profile/account";
export const DELETE_ACCOUNT = API_URL + "/auth/account"

//Signup
export const SIGNUP_URL = API_URL + "/auth/signup";
export const VERIFY_SIGNUP = API_URL + "/auth/verify-signup";

//Roles
export const GET_ROLES = API_URL + "/roles";

//Profile
export const GET_PROFILE = API_URL + "/profile"; //get
export const CHANGE_PASSWORD = API_URL + "/profile/change-password"; //put
export const UPDATE_PROFILE = API_URL + "/profile"; //put
export const UPDATE_DEFAULT_FACILITY = API_URL + "/profile/facility"; //put
export const SEND_OTP_TO_UPDATE_PHONE_EMAIL =
  API_URL + "/profile/send-otp-to-update-phone-email";
export const VERIFY_OTP_TO_UPDATE_PHONE_EMAIL =
  API_URL + "/profile/verify-otp-to-update-phone-email";

//Facility
export const CREATE_FACILITY = API_URL + "/facilities"; //post
export const GET_FACILITY_LIST = (page: string) =>
  API_URL + `/facilities?page=${page}&keyword=`; //get
export const GET_ALL_FACILITY_LIST = (isActive: string = "") =>
  API_URL + `/facilities/all?isActive=${isActive}`;
export const GET_FACILITY_DETAILS = API_URL + "/facilities/:id"; //get
export const UPDATE_FACILITY = API_URL + "/facilities/:id"; //put
export const DELETE_FACILITY = API_URL + "/facilities/:id"; //delete
export const ADD_SPORTS_FOR_FACILITY = API_URL + "/facilities/sports/:id"; //put

//Sport
export const CREATE_SPORT = API_URL + "/sports"; //post
export const GET_SPORT_LIST = (page: string) =>
  API_URL + `/sports?page=${page}&keyword=`; //get
export const GET_ALL_SPORT_LIST = (facilityId: string, isActive: string = "") =>
  `${API_URL}/sports/all?isActive=${isActive}&facilityId=${facilityId}`;
export const GET_SPORT_DETAILS = API_URL + "/sports/:id"; //get
export const UPDATE_SPORT = API_URL + "/sports/:id"; //put
export const DELETE_SPORT = API_URL + "/sports/:id"; //delete
export const DELETE_SPORT_RULE = API_URL + "/sports/rule/:id/:rule";
export const GET_SPORT_OF_FACILITY = (id: string) =>
  API_URL + `/sports/all?isActive=true&facilityId=${id}`;

//Court
export const CREATE_COURT = API_URL + "/courts"; //post
export const GET_COURT_LIST = (page: string) =>
  API_URL + `/courts?page=${page}&keyword=`; //get
export const GET_ALL_COURT_LIST = (
  facilityId: string = "",
  sportId: string = ""
) =>
  `${API_URL}/courts/all?isActive=&facilityId=${facilityId}&sportId=${sportId}`;
export const GET_COURT_FOR_FACILITY_SPORT = (
  fId: string,
  sId: string,
  isActive: string = ""
) =>
  API_URL + `/courts/all?isActive=${isActive}&facilityId=${fId}&sportId=${sId}`;
export const GET_COURT_DETAILS = API_URL + "/courts/:id"; //get
export const UPDATE_COURT = API_URL + "/courts/:id"; //put
export const DELETE_COURT = API_URL + "/courts/:id"; //delete
export const DELETE_COURT_RATES = API_URL + "/courts/rate/:id/:rate";
export const GET_SLOTS_OF_COURT = (id: string, date: string) =>
  API_URL + `/courts/slots-by-court/${id}?bookingDate=${date}`;
export const GET_AVAILABLE_COURT_FOR_SESSION =
  API_URL + "/courts/available-for-session";
export const GET_SLOTS_FOR_ASSOCIATE_BOOKING = (
  startDate: string,
  endDate: string,
  facilityId: string = "",
  sportId: string = ""
) =>
  API_URL +
  `/courts/slots-for-associate-booking?facilityId=${facilityId}&sportId=${sportId}&startDate=${startDate}&endDate=${endDate}`;
export const GET_COURTS_AVAILABLE_FOR_ASSOCIATE_BOOKING =
  API_URL + "/courts/available-for-associate-booking"; //post
export const GET_SLOTS_BY_SPORT = (
  facilityId: string,
  sportId: string,
  date: string,
  courtId: string
) =>
  API_URL +
  `/courts/slots-by-sport?bookingDate=${date}&facilityId=${facilityId}&sportId=${sportId}&courtId=${courtId}`;

//Court_Booking
export const CREATE_COURT_BOOKING = API_URL + "/court-bookings";
export const CREATE_COURT_BOOKING_END_USER =
  API_URL + "/court-bookings/end-user";
export const VALIDATE_BOOKING_USER =
  API_URL + "/users/validate-court-booking-user";
export const COURT_BOOKING_AMOUNT = API_URL + "/court-bookings/amounts";
export const CUSTOMER_COURT_BOOKING_AMOUNT =
  API_URL + "/court-bookings/end-user/amounts";
export const CUSTOMER_COURT_BOOKING_RESCHEDULE_AMOUNT = (id: string) =>
  API_URL + `/court-bookings/end-user/reschedule/amounts/${id}`;
export const SEND_OTP_BOOKING = API_URL + "/profile/send-otp";
export const COURT_BOOKING_LIST = (
  page: string = "",
  key: string = "",
  fromDate: string = "",
  toDate: string = "",
  facilityId: string = "",
  sportName: string = "",
  courtName: string = "",
  bookingType: string = "",
  bookingStatus: string = "",
  paymentStatus: string = "",
  paymentMode: string = "",
  paymentMethod: string = "",
  orderByCol: string = "",
  orderBy: string = "",
  situationType: string = ""
) =>
  API_URL +
  `/court-bookings?page=${page}&keyword=${key}&fromDate=${fromDate}&toDate=${toDate}&facilityId=${facilityId}&situationType=${situationType}&sport=${sportName}&court=${courtName}&bookingType=${bookingType}&status=${bookingStatus}&paymentStatus=${paymentStatus}&paymentMode=${paymentMode}&paymentMethod=${paymentMethod}&orderByCol=${orderByCol}&orderBy=${orderBy}`;
export const BOOKED_COURT_DETAILS = (id: string) =>
  API_URL + `/court-bookings/${id}`;
export const CANCEL_COURT_BOOKING = (id: string) =>
  API_URL + `/court-bookings/cancel/${id}`;
export const RESCHEDULE_COURT_BOOKING = (id: string) =>
  API_URL + `/court-bookings/reschedule/${id}`;
export const CUSTOMER_COURT_BOOKING_RESCHEDULE = (id: string) =>
  API_URL + `/court-bookings/end-user/reschedule/${id}`;
export const RESCHEDULE_AMOUNT = (id: string) =>
  API_URL + `/court-bookings/reschedule/amounts/${id}`;
export const GET_COURT_BOOKING_INVOICE = (id: string) =>
  API_URL + `/court-bookings/invoice/${id}`;
export const GET_COURT_BOOKING_SUMMARY = (id: string) =>
  API_URL + `/court-bookings/summary/${id}`;
export const COURT_BOOKING_COLLECT_CASH = (id: string) =>
  API_URL + `/court-bookings/collect-payment/${id}`;
export const COURT_BOOKING_REFUND = (id: string) =>
  API_URL + `/court-bookings/refund/${id}`;
export const GET_PDF_HTML_FOR_PRINT_API = (type: string, hash: string) =>
  API_URL + `/pdf-html/${type}/${hash}`;
export const DOWNLOAD_COURT_BOOKING_RECORD = (
  // page: string,
  key: string,
  fromDate: string,
  toDate: string,
  facilityId: string,
  sportName: string,
  courtName: string,
  bookingType: string,
  bookingStatus: string,
  paymentStatus: string,
  paymentMode: string,
  paymentMethod: string,
  orderByCol: string,
  orderBy: string
) =>
  API_URL +
  `/court-bookings/download?facilityId=${facilityId}&situationType=&keyword=${key}&fromDate=${fromDate}&toDate=${toDate}&sport=${sportName}&status=${bookingStatus}&paymentStatus=${paymentStatus}&orderByCol=${orderByCol}&orderBy=${orderBy}&court=${courtName}&bookingType=${bookingType}&paymentMode=${paymentMode}&paymentMethod=${paymentMethod}`;
export const COURT_BOOKING_SHARE_PAYMENT_LINK = (id: string) =>
  API_URL + `/court-bookings/share-payment-link/${id}`;

//Rules
export const CREATE_RULE = API_URL + "/rules"; //post
export const GET_RULE_LIST = API_URL + "/rules"; //get
export const GET_RULE_DETAILS = API_URL + "/rules/:id"; //get
export const RULE_STATUS = API_URL + "/rules/status/:id"; //put
export const DELETE_RULE = API_URL + "/rules/:id"; //delete

//Users
export const CREATE_USER = API_URL + "/users"; //post
export const GET_ALL_USER_LIST = API_URL + "/users/all"; //get
export const GET_USER_LIST = (page: string) =>
  API_URL + `/users?page=${page}&keyword=&roleId=`; //get
export const GET_USER_DETAILS = API_URL + "/users/:id"; //get
export const UPDATE_USER = API_URL + "/users/:id"; //put
export const DELETE_USER = API_URL + "/users/:id"; //delete
export const UPDATE_USER_PASSWORD = API_URL + "/users/password/:id"; //put

//Static Data
export const GET_STATE_LIST = API_URL + "/static-data/states";
export const GET_ENUMS = API_URL + "/static-data/enums";

//Session
export const CREATE_SESSION = API_URL + "/sessions"; //post
export const GET_SESSION_LIST = (page: string) =>
  API_URL + `/sessions?page=${page}&keyword=`; //get
export const GET_ALL_SESSION_LIST = (facilityId: string) =>
  `${API_URL}/sessions/all?isActive=true&facilityId=${facilityId}`;
export const GET_AVAILABLE_SESSIONS = (
  facilityId: string,
  sportId: string,
  noOfDays: string
) =>
  `${API_URL}/sessions/available?sportId=${sportId}&facilityId=${facilityId}&noOfDays=${noOfDays}`;
export const GET_SESSION_DETAILS = API_URL + "/sessions/:id"; //get
export const UPDATE_SESSION = API_URL + "/sessions/:id"; //put
export const DELETE_SESSION = API_URL + "/sessions/:id"; //delete
export const DELETE_SESSION_RULE = API_URL + "/sessions/rule/:id/:rule";
export const GET_SESSION_OF_FACILITY = (id: string) =>
  API_URL + `/sessions/all?isActive=true&facilityId=${id}`;
export const VALIDATE_SESSION_BOOKING_ATTENDEE_USER =
  API_URL + "/users/validate-session-booking-user";
export const DELETE_FROM_DATABASE =
  API_URL + "/sessions/:type/:sessionId/:typeId";

//coach
export const CREATE_COACH = API_URL + "/coaches"; //post
export const GET_COACH_LIST = (page: string) =>
  API_URL + `/coaches?page=${page}&keyword=`; //get
export const GET_ALL_COACH_LIST = API_URL + "/users/coaches";
export const GET_COACH_DETAILS = API_URL + "/coaches/:id"; //get
export const UPDATE_COACH = API_URL + "/coaches/:id"; //put
export const DELETE_COACH = API_URL + "/coaches/:id"; //delete
export const DELETE_COACH_RULE = API_URL + "/coaches/rule/:id/:rule";

//Session booking
export const CREATE_COACH_BOOKING = API_URL + "/session-bookings"; //post
export const CREATE_CUSTOMER_COACHING_BOOKING =
  API_URL + "/session-bookings/end-user";
export const GET_COACH_BOOKING_LIST = (payload: any) => {
  let url = API_URL + `/session-bookings?page=${payload?.page}`; //get
  Object.keys(payload)?.forEach?.((_key: string) => {
    if (_key !== "page") {
      url += `&${_key}=${payload[_key]}`;
    }
  });
  return url;
};
export const DOWNLOAD_COACH_BOOKING_REPORT = (payload: any) => {
  let url = API_URL + `/session-bookings/download?`; //get
  Object.keys(payload)?.forEach?.((_key: string) => {
    if (_key !== "page") {
      url += `&${_key}=${payload[_key]}`;
    }
  });
  return url;
};
export const GET_COACH_BOOKING_DETAILS = API_URL + "/session-bookings/:id"; //get
export const GET_ALL_COACH_BOOKING_LIST =
  API_URL + "/session-bookings/all?isActive";
export const REFUND_COACH_BOOKING = API_URL + "/session-bookings/refund/:id";
export const DEACTIVATE_COACH_BOOKING =
  API_URL + "/session-bookings/cancel/:id";
export const PRINT_COACH_BOOKING_INVOICE =
  API_URL + "/session-bookings/invoice/:id";
export const PRINT_COACH_BOOKING_SUMMARY =
  API_URL + "/session-bookings/summary/:id";
export const GET_SESSION_GROUP_SLOTS = (id: string) =>
  API_URL + `/session-bookings/group-slots/${id}?groupType=byDays`;
export const COACHING_BOOKING_SHARE_PAYMENT_LINK = (id: string) =>
  API_URL + `/session-bookings/share-payment-link/${id}`;

//Stock / Inventory
export const GET_ALL_SELLING_PRODUCT_STOCK_LIST = (
  id: string,
  isActive: string = ""
) =>
  API_URL + `/selling-products/all?isActive=${isActive}&facilityId=${id || ""}`; //get
export const GET_SELLING_PRODUCT_STOCK_LIST =
  API_URL + `/selling-products?page=1&keyword=`; //get
export const CREATE_SELLING_PRODUCT_STOCK = API_URL + "/selling-products"; //post
export const GET_SELLING_PRODUCT_DETAILS = API_URL + `/selling-products/:id`; //get
export const UPDATE_SELLING_PRODUCT_DETAILS = API_URL + `/selling-products/:id`; //put
export const DELETE_SELLING_PRODUCT_DETAILS = API_URL + `/selling-products/:id`; //delete
export const GET_SINGLE_SELLING_PRODUCT_HISTORY = (
  id: string,
  year: string,
  month: string
) =>
  API_URL +
  `/selling-products/change-history/${id}?year=${year}&month=${month}`;
export const GET_SELLING_PRODUCT_ORDER_HISTORY = (
  id: string,
  year: string,
  month: string
) =>
  API_URL + `/selling-products/order-history/${id}?year=${year}&month=${month}`;

export const GET_ALL_RENTING_PRODUCT_STOCK_LIST = (
  id: string,
  isActive: string = ""
) =>
  API_URL + `/renting-products/all?isActive=${isActive}&facilityId=${id || ""}`; //get
export const GET_RENTING_PRODUCT_STOCK_LIST =
  API_URL + `/renting-products?page=1&keyword=`; //get
export const CREATE_RENTING_PRODUCT_STOCK = API_URL + "/renting-products"; //post
export const GET_RENTING_PRODUCT_DETAILS = API_URL + `/renting-products/:id`; //get
export const UPDATE_RENTING_PRODUCT_DETAILS = API_URL + `/renting-products/:id`; //put
export const DELETE_RENTING_PRODUCT_DETAILS = API_URL + `/renting-products/:id`; //delete
export const GET_SINGLE_RENTING_PRODUCT_HISTORY = (
  id: string,
  year: string,
  month: string
) =>
  API_URL +
  `/renting-products/change-history/${id}?year=${year}&month=${month}`;
export const GET_RENTING_PRODUCT_ORDER_HISTORY = (
  id: string,
  year: string,
  month: string
) =>
  API_URL + `/renting-products/order-history/${id}?year=${year}&month=${month}`;

export const SESSION_BOOKING_AMOUNT = API_URL + "/session-bookings/amounts";
//POS Admin / Orders
export const GET_ORDER_AMOUNT = API_URL + "/orders/amounts"; //post
export const CREATE_ORDER = API_URL + "/orders"; //post
export const GET_ORDER_INVOICE = API_URL + "/orders/invoice/:id"; //get
export const GET_ORDER_LIST = API_URL + "/orders?page=1&facilityId="; //get
export const GET_ORDER_DETAILS = API_URL + "/orders/:id"; //get
export const VALIDATE_ORDER_USER = API_URL + "/users/validate-order-user";
export const GET_SOLD_ORDER_LIST = (
  page: string,
  facilityId: string,
  key: string,
  fromDate: string,
  toDate: string
) =>
  API_URL +
  `/orders/selling-order-items?page=${page}&facilityId=${facilityId}&keyword=${key}&fromDate=${fromDate}&toDate=${toDate}`;
export const GET_RENTED_ORDER_LIST = (
  page: string,
  facilityId: string,
  key: string,
  fromDate: string,
  toDate: string
) =>
  API_URL +
  `/orders/renting-order-items?page=${page}&facilityId=${facilityId}&keyword=${key}&fromDate=${fromDate}&toDate=${toDate}`;

//setting configuration
export const GET_SETTING_CONFIG = API_URL + "/settings";
export const UPDATE_SETTING_CONFIG = API_URL + "/settings/1";

// Promotional Offers
export const CREATE_PROMOTIONAL_OFFER = API_URL + "/promotional-offers"; //post
export const GET_PROMOTIONAL_OFFERS_LIST = API_URL + "/promotional-offers/all"; //get
export const GET_PROMOTIONAL_OFFER_DETAILS =
  API_URL + "/promotional-offers/:id"; //get
export const UPDATE_PROMOTIONAL_OFFER = API_URL + "/promotional-offers/:id"; //put
export const DELETE_PROMOTIONAL_OFFER = API_URL + "/promotional-offers/:id";

//promotional
export const GET_ALL_PROMOTIONAL_NOTIFICATION_LIST =
  API_URL + "/promotional-notification-templates/all";
export const CREATE_PROMOTIONAL_NOTIFICATION =
  API_URL + "/promotional-notification-templates";
export const UPDATE_PROMOTIONAL_NOTIFICATION =
  API_URL + "/promotional-notification-templates/:id";
export const DELETE_PROMOTIONAL_NOTIFICATION =
  API_URL + "/promotional-notification-templates/:id";
export const GET_PROMOTIONAL_NOTIFICATION =
  API_URL + "/promotional-notification-templates/:id";

//system notification
export const GET_ALL_SYSTEM_NOTIFICATION_TEMPLATES =
  API_URL + "/system-notification-templates/all";
export const UPDATE_SYSTEM_NOTIFICATION_TEMPLATE =
  API_URL + "/system-notification-templates/:id";

//Super/Office Admin Dashboard
export const GET_DASHBOARD_COUNT = API_URL + "/dashboard/counts"; //get
export const GET_BOOKING_SUMMARY_TYPEWISE = (
  fromDate: string,
  toDate: string,
  facilityId: string
) =>
  API_URL +
  `/dashboard/bookings-summary-typewise?fromDate=${fromDate}&toDate=${toDate}&facilityId=${facilityId}`;
export const GET_BOOKING_SUMMARY_SPORTWISE = (
  fromDate: string,
  toDate: string,
  facilityId: string
) =>
  API_URL +
  `/dashboard/bookings-summary-sportwise?fromDate=${fromDate}&toDate=${toDate}&facilityId=${facilityId}`;
export const GET_REVENUE_SUMMARY_TYPEWISE = (
  fromDate: string,
  toDate: string,
  facilityId: string
) =>
  API_URL +
  `/dashboard/revenue-summary-typewise?fromDate=${fromDate}&toDate=${toDate}&facilityId=${facilityId}`;
export const GET_REVENUE_SUMMARY_SPORTWISE = (
  fromDate: string,
  toDate: string,
  facilityId: string
) =>
  API_URL +
  `/dashboard/revenue-summary-sportwise?fromDate=${fromDate}&toDate=${toDate}&facilityId=${facilityId}`;
export const GET_EXIT_BOOKING_LIST = (minutes: string, facilityId: string) =>
  API_URL +
  `/dashboard/exit-booking-slots?minutes=${minutes}&facilityId=${facilityId}`;
export const FACILITY_AVAILABILITY_CHECK = (
  facilityId: string,
  sportId: string,
  startDate: string,
  endDate: string,
  startTime: string,
  endTime: string
) =>
  API_URL +
  `/courts/all-available-slots?facilityId=${facilityId}&sportId=${sportId}&startDate=${startDate}&endDate=${endDate}&startTime=${startTime}&endTime=${endTime}`;

//Associate Booking
export const GET_ASSOCIATE_BOOKING_AMOUNT =
  API_URL + "/associate-court-bookings/amounts";
export const CREATE_ASSOCIATE_BOOKING = API_URL + "/associate-court-bookings";
export const GET_ASSOCIATE_BOOKING_LIST = (
  page: string,
  key: string,
  fromDate: string,
  toDate: string,
  facilityId: string,
  sportId: string,
  bookingStatus: string,
  paymentStatus: string,
  orderByCol: string,
  orderBy: string
) =>
  API_URL +
  `/associate-court-bookings?page=${page}&keyword=${key}&fromDate=${fromDate}&toDate=${toDate}&facilityId=${facilityId}&situationType=&sport=${sportId}&status=${bookingStatus}&paymentStatus=${paymentStatus}&paymentMode=&paymentMethod=&orderByCol=${orderByCol}&orderBy=${orderBy}`;
export const DOWNLOAD_ASSOCIATE_BOOKING_LIST = (
  key: string,
  fromDate: string,
  toDate: string,
  facilityId: string,
  sportId: string,
  bookingStatus: string,
  paymentStatus: string,
  orderByCol: string,
  orderBy: string
) =>
  API_URL +
  `/associate-court-bookings/download?keyword=${key}&fromDate=${fromDate}&toDate=${toDate}&facilityId=${facilityId}&situationType=&sport=${sportId}&status=${bookingStatus}&paymentStatus=${paymentStatus}&paymentMode=&paymentMethod=&orderByCol=${orderByCol}&orderBy=${orderBy}`;
export const GET_ASSOCIATE_BOOKING_DETAILS = (
  id: string,
  bookingDate: string
) => API_URL + `/associate-court-bookings/${id}?bookingDate=${bookingDate}`;
export const CANCLE_ASSOCIATE_BOOKING = (id: string) =>
  API_URL + `/associate-court-bookings/cancel/${id}`;
export const GENERATE_ASSOCIATE_INVOICE = (
  bookingId: string,
  invoiceId: string
) =>
  API_URL +
  `/associate-court-bookings/generate-payment/${bookingId}/${invoiceId}`;
export const COLLECT_ASSOCIATE_INVOICE_PAYMENT = (
  bookingId: string,
  invoiceId: string
) =>
  API_URL +
  `/associate-court-bookings/collect-payment/${bookingId}/${invoiceId}`;
export const DOWNLOAD_ASSOCIATE_INVOICE = (
  bookingId: string,
  invoiceId: string
) =>
  API_URL +
  `/associate-court-bookings/download-invoice/${bookingId}/${invoiceId}`;
export const PRINT_ASSOCIATE_SUMMARY = (bookingId: string) =>
  API_URL + `/associate-court-bookings/summary/${bookingId}`;
export const REFUND_ASSOCIATE_BOOKING = (bookingId: string) =>
  API_URL + `/associate-court-bookings/refund/${bookingId}`;
export const GET_GROUP_SLOTS = (bookingId: string, isReschedule: string) =>
  API_URL +
  `/associate-court-bookings/group-slots/${bookingId}?groupBy=timeAndRate&groupType=byDays&isReschedule=${isReschedule}`;
export const ASSOCIATE_RESCHEDULE_CANCEL_SLOTS = (bookingId: string) =>
  API_URL +
  `/associate-court-bookings/reschedule/cancel-booking-slots/${bookingId}`;
export const ASSOCIATE_RESCHEDULE_UPDATE_END_DATE = (bookingId: string) =>
  API_URL +
  `/associate-court-bookings/reschedule/update-booking-end-date/${bookingId}`;
export const ASSOCIATE_RESCHEDULE_DELETE_COURT = (bookingId: string) =>
  API_URL +
  `/associate-court-bookings/reschedule/delete-booking-courts/${bookingId}`;
export const ASSOCIATE_RESCHEDULE_ADD_BOOKING_SLOTS = (bookingId: string) =>
  API_URL +
  `/associate-court-bookings/reschedule/add-booking-slots/${bookingId}`;
export const ASSOCIATE_RESCHEDULE_ADD_BOOKING_COURTS = (bookingId: string) =>
  API_URL +
  `/associate-court-bookings/reschedule/add-booking-courts/${bookingId}`;

//Data Retention
export const DATA_RETENTION_CHECK = API_URL + "/profile/data-retention-check";
export const DATA_RETENTION_CHOICE = API_URL + "/profile/data-retention-choice";

//Notification
export const GET_USER_NOTIFICATION = (page: any) =>
  API_URL + `/user-notifications?page=${page}`;
export const GET_NOTIFICATION_COUNT = API_URL + "/user-notifications/unseen";
